import React from 'react';
import { PlayerStatusContainer } from '../../../components/display/PlayerStatusContainer';

export const PlayerWarTransitionView: React.FC = () => {
    return <PlayerStatusContainer title="WAR!" subtitle="Prepare for the showdown..." />;
};
